import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { Toaster } from '@/components/ui/sonner';
import HomePage from '@/pages/HomePage';
import BoutiquePage from '@/pages/BoutiquePage';
import ProductPage from '@/pages/ProductPage';
import AboutPage from '@/pages/AboutPage';
import ContactPage from '@/pages/ContactPage';
import AdminLoginPage from '@/pages/admin/AdminLoginPage';
import AdminDashboardPage from '@/pages/admin/AdminDashboardPage';
import AdminQuoteDetailPage from '@/pages/admin/AdminQuoteDetailPage';
import ProtectedRoute from '@/pages/admin/ProtectedRoute';
import MentionsLegalesPage from '@/pages/MentionsLegalesPage';
import ConfidentialitePage from '@/pages/ConfidentialitePage';
import CGVPage from '@/pages/CGVPage';
import PublicLayout from '@/layouts/PublicLayout';
import { QuoteProvider } from '@/context/QuoteContext';
import '@/App.css';

function App() {
  return (
    <HelmetProvider>
    <div className="App">
      <QuoteProvider>
        <BrowserRouter>
          <Routes>
            <Route element={<PublicLayout />}>
              <Route path="/" element={<HomePage />} />
              <Route path="/boutique" element={<BoutiquePage />} />
              <Route path="/produit/:slug" element={<ProductPage />} />
              <Route path="/a-propos" element={<AboutPage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/mentions-legales" element={<MentionsLegalesPage />} />
              <Route path="/confidentialite" element={<ConfidentialitePage />} />
              <Route path="/cgv" element={<CGVPage />} />
            </Route>
            <Route path="/admin/login" element={<AdminLoginPage />} />
            <Route path="/admin" element={<ProtectedRoute><AdminDashboardPage /></ProtectedRoute>} />
            <Route path="/admin/devis/:id" element={<ProtectedRoute><AdminQuoteDetailPage /></ProtectedRoute>} />
          </Routes>
        </BrowserRouter>
        <Toaster richColors position="top-right" />
      </QuoteProvider>
    </div>
    </HelmetProvider>
  );
}

export default App;
